import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { ClientRepItem } from 'types/LegalPartner';

export const useGetBRPartnerDetails = (ids: string[], usedInBr: boolean, keepPreviousData = false) => {
  return useQuery<ClientRepItem[], AxiosError>({
    queryKey: ['useGetBRPartnerDetails', ids],
    queryFn: () => contactNoteDialogService.getBRPartnerDetails(ids),
    select: (data) => {
      return data.map((item) => ({ ...item, dateOfOrigin: item?.dateOfOrigin?.split('-').join('') }));
    },
    enabled: ids.length > 0 && usedInBr,
    keepPreviousData,
  });
};
